<template>
	<div class="panel_sale">
		<div class="list" v-if="type==='list'">
			<ylfwList></ylfwList>
		</div>
		<div class="add" v-if="type==='add'">
			<ylfwAdd></ylfwAdd>
		</div>
		<div class="add" v-if="type==='edit'">
			<ylfwEdit></ylfwEdit>
		</div>
		<div class="add" v-if="type==='see'">
			<ylfwSee></ylfwSee>
		</div>
		<div class="list" v-if="type==='packageList'">
			<ylfwPackageList></ylfwPackageList>
		</div>
		<div class="list" v-if="type==='packageSee'">
			<ylfwPackageSee></ylfwPackageSee>
		</div>
	</div>
</template>
<script>
	import ylfwList from "../comp/ylfw_list.vue"
	import ylfwAdd from "../comp/ylfw_add.vue"
	import ylfwEdit from "../comp/ylfw_edit.vue"
	import ylfwSee from "../comp/ylfw_see.vue"
	import ylfwPackageList from "../comp/ylfwPackage_list.vue"
	import ylfwPackageSee from "../comp/ylfwPackage_see.vue"
	export default {
		components:{ylfwList,ylfwAdd,ylfwEdit,ylfwSee,ylfwPackageList,ylfwPackageSee},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.yiliaoxin.ylfwParams.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	width:100%;
	height: calc(100% - 145px);margin-top:12px;
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
